<template>
  <silo-list-view v-if="!this.$route.query.id" :campaignId="campaignId" :currentCampaign="currentCampaign"/>
  <silo-single-view v-else :campaignId="campaignId" :currentCampaign="currentCampaign"/>
</template>

<script>
import SiloListView from './SiloListView.vue';
import SiloSingleView from './SiloSingleView.vue';

export default {
  props: ['campaignId', 'currentCampaign'],
  components: {
    SiloListView,
    SiloSingleView,
  }
};

</script>

<style lang="scss" scoped>
@import './silo.scss';
</style>
